import { subscribeKey } from 'valtio/utils';

import { waitForContentAPI } from '@canvas/frame-api/host-api/host-frame-context';
import { currentDrawerPanel } from '@canvas/sidebar-panel-state';

export function setupCommentsPanelBridgeListeners() {
  subscribeKey(currentDrawerPanel, 'panel', (value) => {
    if (value === 'commentsPanel') {
      waitForContentAPI().then((canvasFrameAPI) => {
        canvasFrameAPI?.confluenceAPI?.comments?.triggerCommentPanelRefresh?.();
      });
    }
  });
}
